function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, activeColumn, labelsCropped, links, selectedNode, tooltip, topPath) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['link-tooltip'] = function({
      breakdown,
      edge,
      top,
      left
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const count = breakdown ? breakdown.totalCount : edge.totalCount;;
        const percentage = $helpers.abbreviateNumber((count / edge.fromNode.totalCount) * 100);;
        const fromCount = $helpers.commaizeNumber(edge.fromNode.totalCount);;
        const edgeCount = $helpers.commaizeNumber(count);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": 'sankey-tooltip',
          "style": {
            left: `${left}px`,
            top: `${top}px`,
          },
          "class": Object.assign({}, {
            'is-visible': percentage >= 5
          }, {
            'sankey-tooltip': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'sankey-link-tooltip-path-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-node-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": Object.assign({}, {
                  [`is-${edge.fromNode.type.toLowerCase()}`]: true
                }, {
                  'sankey-link-step-bubble': true
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($helpers.renameEvents(edge.fromNode.eventString))]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sankey-link-tooltip-node-connector': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-node-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  [`is-${edge.toNode.type.toLowerCase()}`]: true
                }, {
                  'span': true,
                  'sankey-link-step-bubble': true
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode($helpers.renameEvents(edge.toNode.eventString))]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'sankey-link-tooltip-weight': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (edgeCount) + " of " + (fromCount) + " " + (percentage) + "%");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((breakdown && breakdown.timePercentilesFromStart.length) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-weight': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Median time from start " + ($helpers.formatConciseDuration(breakdown.timePercentilesFromStart[0])) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((breakdown && breakdown.timePercentilesFromPrev.length) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-link-tooltip-weight': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Median time from previous step " + ($helpers.formatConciseDuration(breakdown.timePercentilesFromPrev[0])) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['node-label'] = function({
      node,
      nodeAttributes,
      anchorStepWeight
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": `label-${node.id}`,
          "style": {
            height: `${nodeAttributes.height}px`
          },
          "class": {
            'sankey-node-label-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.onNodeClicked,
              contextmenu: ev => $helpers.showContextMenu(ev, node),
            },
            "props": {
              node,
              nodeAttributes
            },
            "class": Object.assign({}, {
              'is-center_aligned': nodeAttributes.height <= $helpers.nodeLabelMinHeight,
              'is-in-top-path': nodeAttributes.isInTopPath,
            }, {
              'sankey-node-label': true
            }),
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-node-arrow': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'sankey-node-label-content': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'sankey-node-name-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-node-name': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($helpers.renameEvents(node.eventString));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-node-weight': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(`${$helpers.abbreviateNumber(node.totalCount / anchorStepWeight * 100)}%`);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (node.segments);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'sankey-segment-value': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("b", (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("" + (segment.label) + ":");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(` ${segment.value}`);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var segment = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'sankey-segment-value': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("b", (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat("" + (segment.label) + ":");;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat(` ${segment.value}`);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());
              __jade_nodes = __jade_nodes.concat((selectedNode === node.id && node.breakdowns.length > 1) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-node-breakdown-percents': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (node.breakdowns);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              '--breakdown-bg-color': breakdownAttributes.color
                            },
                            "class": {
                              'sankey-node-breakdown-percent': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(`${$helpers.abbreviateNumber(breakdown.totalCount / node.totalCount * 100)}%`);
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                placement: 'left',
                                'max-width': '200px'
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(breakdownAttributes.name)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var breakdown = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": {
                                  '--breakdown-bg-color': breakdownAttributes.color
                                },
                                "class": {
                                  'sankey-node-breakdown-percent': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(`${$helpers.abbreviateNumber(breakdown.totalCount / node.totalCount * 100)}%`);
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": {
                                    placement: 'left',
                                    'max-width': '200px'
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(breakdownAttributes.name)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const steps = $component.data.steps;;
    const breakdowns = $component.data.breakdowns;;
    return {
      value: (h("div", {
        "on": {
          mouseleave: $helpers.onMouseLeave,
          mousemove: $helpers.onMouseMove,
        },
        "class": Object.assign({}, {
          'is-loaded': steps && steps.length ? labelsCropped && links !== null : true,
          'is-reverse': $attr(`reverse`),
          'is-top-path-mode': topPath.size > 0,
        }, {
          'sankey': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((steps) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!steps.length) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `empty-state`
              },
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            const anchorStep = $helpers.getFlowAnchorStep();;
            const anchorStepWeight = anchorStep.weight;;
            const weight = $helpers.abbreviateNumber(anchorStepWeight);;
            const weightLabel = $helpers.pluralize(`Event`, anchorStepWeight);; /*  tooltip for when hovering over node links */
            __jade_nodes = __jade_nodes.concat((tooltip) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(jade_mixins['link-tooltip'].call(this, tooltip));;
              return __jade_nodes
            }).call(this)) : undefined); /*  wrapper for scrolling inner table contents */
            __jade_nodes = __jade_nodes.concat(h("div", {
              "key": `sankey`,
              "on": {
                scroll: $helpers.closeContextMenu
              },
              "class": {
                'sankey-table-scroller': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "hook": {
                  insert: $helpers.onTableInserted,
                  postpatch: $helpers.onTablePatched,
                },
                "class": {
                  'sankey-table': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((breakdowns.length > 1) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-legend': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-chart-legend", {
                      "attrs": {
                        'read-only': true,
                        'sections': JSON.stringify($helpers.getBreakdownSections()),
                        'style-override': require('./legend.styl?inline'),
                        'wrap-labels': true,
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'sankey-table-content': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-table-headers': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (steps);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, step, stepIndex) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            const displayContextMenu = $helpers.canRemoveSteps() && stepIndex === ($attr(`reverse`) ? 0 : steps.length - 1);;
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": Object.assign({}, {
                                'has-context_menu': displayContextMenu
                              }, {
                                'sankey-table-column': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", {
                                "hook": {
                                  insert: step.isAnchor ? $helpers.truncateHeader : null
                                },
                                "on": {
                                  click: () => $helpers.onColumnHeaderClick(stepIndex)
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(($attr(`anchor-event-labels`) && step.isAnchor) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(step.nodes.length && step.nodes[0].eventString);;
                                  return __jade_nodes
                                }).call(this)) : ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat("Step " + (stepIndex + 1) + "");;
                                  return __jade_nodes
                                }).call(this)));
                                __jade_nodes = __jade_nodes.concat((displayContextMenu) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                    "attrs": {
                                      icon: 'caret-down'
                                    },
                                  }));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat((displayContextMenu) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                                  "attrs": {
                                    open: activeColumn === stepIndex
                                  },
                                  "on": {
                                    change: $helpers.activeColumnMenuChange
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("button", {
                                    "on": {
                                      click: $helpers.onRemoveStepClick
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                      "attrs": {
                                        icon: 'x'
                                      },
                                    }));
                                    __jade_nodes = __jade_nodes.concat(`Remove Step`);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var stepIndex = $$objKey;
                            if ($$obj.hasOwnProperty(stepIndex)) {
                              $$iterated = true;
                              var step = $$obj[stepIndex];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                const displayContextMenu = $helpers.canRemoveSteps() && stepIndex === ($attr(`reverse`) ? 0 : steps.length - 1);;
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": Object.assign({}, {
                                    'has-context_menu': displayContextMenu
                                  }, {
                                    'sankey-table-column': true
                                  }),
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "hook": {
                                      insert: step.isAnchor ? $helpers.truncateHeader : null
                                    },
                                    "on": {
                                      click: () => $helpers.onColumnHeaderClick(stepIndex)
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(($attr(`anchor-event-labels`) && step.isAnchor) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(step.nodes.length && step.nodes[0].eventString);;
                                      return __jade_nodes
                                    }).call(this)) : ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat("Step " + (stepIndex + 1) + "");;
                                      return __jade_nodes
                                    }).call(this)));
                                    __jade_nodes = __jade_nodes.concat((displayContextMenu) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                        "attrs": {
                                          icon: 'caret-down'
                                        },
                                      }));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat((displayContextMenu) ? ((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
                                      "attrs": {
                                        open: activeColumn === stepIndex
                                      },
                                      "on": {
                                        change: $helpers.activeColumnMenuChange
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("button", {
                                        "on": {
                                          click: $helpers.onRemoveStepClick
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                                          "attrs": {
                                            icon: 'x'
                                          },
                                        }));
                                        __jade_nodes = __jade_nodes.concat(`Remove Step`);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this)) : undefined);;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());
                    __jade_nodes = __jade_nodes.concat(($attr(`allow-add-step`)) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'sankey-table-column': true,
                          'for-add-step': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Add Step");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'sankey-table-body': true
                    },
                  }, (function() {
                    var __jade_nodes = []; /*  link shapes for all nodes */
                    __jade_nodes = __jade_nodes.concat(h("svg", {
                      "class": {
                        'sankey-links': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((function() {
                        var $$obj = ((links || []));
                        var $$eachNodes;
                        var $$iterated = false;
                        if (Array.isArray($$obj)) {
                          $$eachNodes = $$obj.reduce(function($$eachNodes, link, $index) {
                            $$iterated = true;
                            return $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("path", {
                                "attrs": link.attrs,
                                "props": link.props,
                                "style": {
                                  '--breakdown-bg-color': link.color
                                },
                                "class": link.class,
                              }));;
                              return __jade_nodes
                            }).call(this));
                          }, []);
                        } else {
                          $$eachNodes = [];
                          for (var $$objKey in $$obj) {
                            (function() {
                              var $index = $$objKey;
                              if ($$obj.hasOwnProperty($index)) {
                                $$iterated = true;
                                var link = $$obj[$index];
                                $$eachNodes = $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("path", {
                                    "attrs": link.attrs,
                                    "props": link.props,
                                    "style": {
                                      '--breakdown-bg-color': link.color
                                    },
                                    "class": link.class,
                                  }));;
                                  return __jade_nodes
                                }).call(this));
                              }
                            })();
                          }
                        }

                        return $$eachNodes;
                      })());;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (steps);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, step, stepIndex) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'sankey-table-column': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat((function() {
                                var $$obj = (step.nodes);
                                var $$eachNodes;
                                var $$iterated = false;
                                if (Array.isArray($$obj)) {
                                  $$eachNodes = $$obj.reduce(function($$eachNodes, node, $index) {
                                    $$iterated = true;
                                    return $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      const nodeAttributes = $helpers.getNodeAttributes(node);;
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'sankey-node-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "dataset": {
                                            id: node.id
                                          },
                                          "on": {
                                            click: $helpers.onNodeClicked,
                                            contextmenu: ev => $helpers.showContextMenu(ev, node),
                                          },
                                          "props": {
                                            node
                                          },
                                          "class": Object.assign({}, {
                                            'is-active': selectedNode === node.id,
                                            'is-in-top-path': nodeAttributes.isInTopPath,
                                            [`is-${nodeAttributes.nodeType}`]: true,
                                          }, {
                                            'sankey-node': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat((function() {
                                            var $$obj = (node.breakdowns);
                                            var $$eachNodes;
                                            var $$iterated = false;
                                            if (Array.isArray($$obj)) {
                                              $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                $$iterated = true;
                                                return $$eachNodes.concat((function() {
                                                  var __jade_nodes = [];
                                                  const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                                    "style": {
                                                      height: `${breakdownAttributes.height}px`,
                                                      '--breakdown-bg-color': breakdownAttributes.color
                                                    },
                                                    "class": Object.assign({}, {
                                                      'is-active': selectedNode === node.id,
                                                      'is-broken-down': breakdowns.length > 1,
                                                      [`is-${nodeAttributes.nodeType}`]: true
                                                    }, {
                                                      'sankey-node-breakdown': true
                                                    }),
                                                  }));;
                                                  return __jade_nodes
                                                }).call(this));
                                              }, []);
                                            } else {
                                              $$eachNodes = [];
                                              for (var $$objKey in $$obj) {
                                                (function() {
                                                  var $index = $$objKey;
                                                  if ($$obj.hasOwnProperty($index)) {
                                                    $$iterated = true;
                                                    var breakdown = $$obj[$index];
                                                    $$eachNodes = $$eachNodes.concat((function() {
                                                      var __jade_nodes = [];
                                                      const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                                        "style": {
                                                          height: `${breakdownAttributes.height}px`,
                                                          '--breakdown-bg-color': breakdownAttributes.color
                                                        },
                                                        "class": Object.assign({}, {
                                                          'is-active': selectedNode === node.id,
                                                          'is-broken-down': breakdowns.length > 1,
                                                          [`is-${nodeAttributes.nodeType}`]: true
                                                        }, {
                                                          'sankey-node-breakdown': true
                                                        }),
                                                      }));;
                                                      return __jade_nodes
                                                    }).call(this));
                                                  }
                                                })();
                                              }
                                            }

                                            return $$eachNodes;
                                          })());;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));
                                        __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                          node,
                                          nodeAttributes,
                                          anchorStepWeight
                                        }));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }, []);
                                } else {
                                  $$eachNodes = [];
                                  for (var $$objKey in $$obj) {
                                    (function() {
                                      var $index = $$objKey;
                                      if ($$obj.hasOwnProperty($index)) {
                                        $$iterated = true;
                                        var node = $$obj[$index];
                                        $$eachNodes = $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          const nodeAttributes = $helpers.getNodeAttributes(node);;
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'sankey-node-wrapper': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "dataset": {
                                                id: node.id
                                              },
                                              "on": {
                                                click: $helpers.onNodeClicked,
                                                contextmenu: ev => $helpers.showContextMenu(ev, node),
                                              },
                                              "props": {
                                                node
                                              },
                                              "class": Object.assign({}, {
                                                'is-active': selectedNode === node.id,
                                                'is-in-top-path': nodeAttributes.isInTopPath,
                                                [`is-${nodeAttributes.nodeType}`]: true,
                                              }, {
                                                'sankey-node': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat((function() {
                                                var $$obj = (node.breakdowns);
                                                var $$eachNodes;
                                                var $$iterated = false;
                                                if (Array.isArray($$obj)) {
                                                  $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                    $$iterated = true;
                                                    return $$eachNodes.concat((function() {
                                                      var __jade_nodes = [];
                                                      const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                                        "style": {
                                                          height: `${breakdownAttributes.height}px`,
                                                          '--breakdown-bg-color': breakdownAttributes.color
                                                        },
                                                        "class": Object.assign({}, {
                                                          'is-active': selectedNode === node.id,
                                                          'is-broken-down': breakdowns.length > 1,
                                                          [`is-${nodeAttributes.nodeType}`]: true
                                                        }, {
                                                          'sankey-node-breakdown': true
                                                        }),
                                                      }));;
                                                      return __jade_nodes
                                                    }).call(this));
                                                  }, []);
                                                } else {
                                                  $$eachNodes = [];
                                                  for (var $$objKey in $$obj) {
                                                    (function() {
                                                      var $index = $$objKey;
                                                      if ($$obj.hasOwnProperty($index)) {
                                                        $$iterated = true;
                                                        var breakdown = $$obj[$index];
                                                        $$eachNodes = $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                                            "style": {
                                                              height: `${breakdownAttributes.height}px`,
                                                              '--breakdown-bg-color': breakdownAttributes.color
                                                            },
                                                            "class": Object.assign({}, {
                                                              'is-active': selectedNode === node.id,
                                                              'is-broken-down': breakdowns.length > 1,
                                                              [`is-${nodeAttributes.nodeType}`]: true
                                                            }, {
                                                              'sankey-node-breakdown': true
                                                            }),
                                                          }));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }
                                                    })();
                                                  }
                                                }

                                                return $$eachNodes;
                                              })());;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                              node,
                                              nodeAttributes,
                                              anchorStepWeight
                                            }));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this));
                                      }
                                    })();
                                  }
                                }

                                return $$eachNodes;
                              })());;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var stepIndex = $$objKey;
                            if ($$obj.hasOwnProperty(stepIndex)) {
                              $$iterated = true;
                              var step = $$obj[stepIndex];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'sankey-table-column': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat((function() {
                                    var $$obj = (step.nodes);
                                    var $$eachNodes;
                                    var $$iterated = false;
                                    if (Array.isArray($$obj)) {
                                      $$eachNodes = $$obj.reduce(function($$eachNodes, node, $index) {
                                        $$iterated = true;
                                        return $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          const nodeAttributes = $helpers.getNodeAttributes(node);;
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'sankey-node-wrapper': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "dataset": {
                                                id: node.id
                                              },
                                              "on": {
                                                click: $helpers.onNodeClicked,
                                                contextmenu: ev => $helpers.showContextMenu(ev, node),
                                              },
                                              "props": {
                                                node
                                              },
                                              "class": Object.assign({}, {
                                                'is-active': selectedNode === node.id,
                                                'is-in-top-path': nodeAttributes.isInTopPath,
                                                [`is-${nodeAttributes.nodeType}`]: true,
                                              }, {
                                                'sankey-node': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat((function() {
                                                var $$obj = (node.breakdowns);
                                                var $$eachNodes;
                                                var $$iterated = false;
                                                if (Array.isArray($$obj)) {
                                                  $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                    $$iterated = true;
                                                    return $$eachNodes.concat((function() {
                                                      var __jade_nodes = [];
                                                      const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                                        "style": {
                                                          height: `${breakdownAttributes.height}px`,
                                                          '--breakdown-bg-color': breakdownAttributes.color
                                                        },
                                                        "class": Object.assign({}, {
                                                          'is-active': selectedNode === node.id,
                                                          'is-broken-down': breakdowns.length > 1,
                                                          [`is-${nodeAttributes.nodeType}`]: true
                                                        }, {
                                                          'sankey-node-breakdown': true
                                                        }),
                                                      }));;
                                                      return __jade_nodes
                                                    }).call(this));
                                                  }, []);
                                                } else {
                                                  $$eachNodes = [];
                                                  for (var $$objKey in $$obj) {
                                                    (function() {
                                                      var $index = $$objKey;
                                                      if ($$obj.hasOwnProperty($index)) {
                                                        $$iterated = true;
                                                        var breakdown = $$obj[$index];
                                                        $$eachNodes = $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                                            "style": {
                                                              height: `${breakdownAttributes.height}px`,
                                                              '--breakdown-bg-color': breakdownAttributes.color
                                                            },
                                                            "class": Object.assign({}, {
                                                              'is-active': selectedNode === node.id,
                                                              'is-broken-down': breakdowns.length > 1,
                                                              [`is-${nodeAttributes.nodeType}`]: true
                                                            }, {
                                                              'sankey-node-breakdown': true
                                                            }),
                                                          }));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }
                                                    })();
                                                  }
                                                }

                                                return $$eachNodes;
                                              })());;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                              node,
                                              nodeAttributes,
                                              anchorStepWeight
                                            }));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this));
                                      }, []);
                                    } else {
                                      $$eachNodes = [];
                                      for (var $$objKey in $$obj) {
                                        (function() {
                                          var $index = $$objKey;
                                          if ($$obj.hasOwnProperty($index)) {
                                            $$iterated = true;
                                            var node = $$obj[$index];
                                            $$eachNodes = $$eachNodes.concat((function() {
                                              var __jade_nodes = [];
                                              const nodeAttributes = $helpers.getNodeAttributes(node);;
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "class": {
                                                  'sankey-node-wrapper': true
                                                },
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "dataset": {
                                                    id: node.id
                                                  },
                                                  "on": {
                                                    click: $helpers.onNodeClicked,
                                                    contextmenu: ev => $helpers.showContextMenu(ev, node),
                                                  },
                                                  "props": {
                                                    node
                                                  },
                                                  "class": Object.assign({}, {
                                                    'is-active': selectedNode === node.id,
                                                    'is-in-top-path': nodeAttributes.isInTopPath,
                                                    [`is-${nodeAttributes.nodeType}`]: true,
                                                  }, {
                                                    'sankey-node': true
                                                  }),
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat((function() {
                                                    var $$obj = (node.breakdowns);
                                                    var $$eachNodes;
                                                    var $$iterated = false;
                                                    if (Array.isArray($$obj)) {
                                                      $$eachNodes = $$obj.reduce(function($$eachNodes, breakdown, $index) {
                                                        $$iterated = true;
                                                        return $$eachNodes.concat((function() {
                                                          var __jade_nodes = [];
                                                          const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                                            "style": {
                                                              height: `${breakdownAttributes.height}px`,
                                                              '--breakdown-bg-color': breakdownAttributes.color
                                                            },
                                                            "class": Object.assign({}, {
                                                              'is-active': selectedNode === node.id,
                                                              'is-broken-down': breakdowns.length > 1,
                                                              [`is-${nodeAttributes.nodeType}`]: true
                                                            }, {
                                                              'sankey-node-breakdown': true
                                                            }),
                                                          }));;
                                                          return __jade_nodes
                                                        }).call(this));
                                                      }, []);
                                                    } else {
                                                      $$eachNodes = [];
                                                      for (var $$objKey in $$obj) {
                                                        (function() {
                                                          var $index = $$objKey;
                                                          if ($$obj.hasOwnProperty($index)) {
                                                            $$iterated = true;
                                                            var breakdown = $$obj[$index];
                                                            $$eachNodes = $$eachNodes.concat((function() {
                                                              var __jade_nodes = [];
                                                              const breakdownAttributes = $helpers.getBreakdownAttributes(breakdown);;
                                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                                "style": {
                                                                  height: `${breakdownAttributes.height}px`,
                                                                  '--breakdown-bg-color': breakdownAttributes.color
                                                                },
                                                                "class": Object.assign({}, {
                                                                  'is-active': selectedNode === node.id,
                                                                  'is-broken-down': breakdowns.length > 1,
                                                                  [`is-${nodeAttributes.nodeType}`]: true
                                                                }, {
                                                                  'sankey-node-breakdown': true
                                                                }),
                                                              }));;
                                                              return __jade_nodes
                                                            }).call(this));
                                                          }
                                                        })();
                                                      }
                                                    }

                                                    return $$eachNodes;
                                                  })());;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));
                                                __jade_nodes = __jade_nodes.concat(jade_mixins['node-label'].call(this, {
                                                  node,
                                                  nodeAttributes,
                                                  anchorStepWeight
                                                }));;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this));
                                          }
                                        })();
                                      }
                                    }

                                    return $$eachNodes;
                                  })());;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());
                    __jade_nodes = __jade_nodes.concat(($attr(`allow-add-step`)) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'sankey-table-column': true,
                          'for-add-step': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": {
                            size: `small`,
                            icon: `plus`
                          },
                          "on": {
                            click: $helpers.onAddStepClick
                          },
                          "class": {
                            'mp-button-secondary': true
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "activeColumn" in locals ? locals.activeColumn : typeof activeColumn !== "undefined" ? activeColumn : undefined, "labelsCropped" in locals ? locals.labelsCropped : typeof labelsCropped !== "undefined" ? labelsCropped : undefined, "links" in locals ? locals.links : typeof links !== "undefined" ? links : undefined, "selectedNode" in locals ? locals.selectedNode : typeof selectedNode !== "undefined" ? selectedNode : undefined, "tooltip" in locals ? locals.tooltip : typeof tooltip !== "undefined" ? tooltip : undefined, "topPath" in locals ? locals.topPath : typeof topPath !== "undefined" ? topPath : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;